const th = {
  translation: {
    home: "หน้าแรก",
    login: "เข้าสู่ระบบ",
    register: "ลงทะเบียนเลย",
    confirm: "ยืนยัน",
    language: "ภาษา",
    pleaseEnterUsername: "กรุณากรอกชื่อผู้ใช้/หมายเลขโทรศัพท์มือถือ",
    pleaseEnterPassword: "กรุณาใส่รหัสผ่าน",
    pleaseConfirmPassword: "กรุณายืนยันรหัสผ่าน",
    registerSuccessText: "ลงทะเบียนสำเร็จ เข้าสู่ระบบเลย",
    wrongCredential: "ชื่อผู้ใช้ หรือ รหัสผ่าน ไม่ถูกต้อง",
    loginSuccessText: "การเข้าสู่ระบบสำเร็จ",
    recharge: "เติมเงิน",
    trend: "แนวโน้ม",
    profile: "โปรไฟล์",
    promotion: "โปรโมชั่น",
    productDetail: "รายละเอียดสินค้า",
    onlineService: "บริการออนไลน์",
    productDetailContent:
      "เรียนลูกค้า วิธีการเติมเงินจะได้รับการอัปเดตตามเวลาจริง โปรดปรึกษาฝ่ายบริการลูกค้าก่อนการเติมเงินแต่ละครั้งเพื่อรับบัญชีธนาคารล่าสุด หากโอนเงินผิดบัญชีหรือเติมเงินที่ไม่สอดคล้องกับวิธีการบริการลูกค้าจะส่งผลให้ ถือเป็นโมฆะการสูญเสียจะตกเป็นภาระของบริษัทของเรา ขาดความรับผิดชอบ! ! เวลาให้บริการ 09:30-23:30 น. ทุกวัน ขอบคุณที่สนับสนุน ETF ขอให้ชีวิตมีความสุข!",
    productDetailContent1:
      "1. วิธีทำกิจกรรม (แพลตฟอร์ม) จะมีสามตัวที่นับรวมกัน (เช่น 3+5+2=10 เรียกว่า เล็ก) ถ้ามากกว่า 10 เรียกว่า ใหญ่ ( 1-10 เล็ก) ( 11-18 ใหญ่) 1,3,5,7,9,11, 13,15,17 (คี่); 2,4,6,8,10,12,14,16,18 (คู่)",
    productDetailContent2:
      "2. ผลการทำกิจกรรม (หลักพัน) ขึ้นอยู่กับจำนวนเงินที่ลูกค้าใช้ไป",
    productDetailContent3:
      "3. อัตราค่าเดินทางขึ้นอยู่กับระดับห้อง (เริ่มต้น, กลาง, VIP)",
    rechargeOffline: "เติมเงินออฟไลน์",
    bankToPay: "ธนาคารออนไลน์ที่ต้องชำระเงิน",
    rechargeOnlineBank: "ติดต่อฝ่ายบริการ",
    cancel: "ยกเลิก",
    pleaseEnterRechargeAmount: "กรุณาเลือกจำนวนเงินที่เติม",
    pleaseEnterNickname: "โปรดป้อนชื่อเล่น",
    fundDetail: "รายละเอียดเงินทุน",
    investmentRecord: "บันทึกการลงทุน",
    securityCenter: "ศูนย์รักษาความปลอดภัย",
    customerService: "ติดต่อฝ่ายบริการ",
    setting: "การตั้งค่า",
    balance: "ยอดเงินในบัญชี",
    todayProfit: "กำไรและขาดทุนวันนี้นี้",
    loginPassword: "รหัสผ่านในการเข้าสู่ระบบ",
    withdrawPassword: "รหัสผ่านการถอน",
    connectBankAccount: "เพิ่มข้อมูลในการถอนเงิน",
    updateLoginPassword: "อัปเดตรหัสผ่านเข้าสู่ระบบ",
    oldPassword: "รหัสผ่านเก่า",
    newPassword: "รหัสผ่านใหม่",
    confirmNewPassword: "ยืนยันรหัสผ่านใหม่",
    pleaseenterOldPassword: "โปรดป้อนรหัสผ่านเก่า",
    pleaseenterNewPassword: "โปรดป้อนรหัสผ่านใหม่",
    oldPasswordIncorrect: "รหัสผ่านเก่าไม่ถูกต้อง",
    passwordNotMatch: "รหัสผ่านไม่ตรงกัน",
    updateWithdrawPassword: "อัปเดตรหัสผ่านการถอนเงิน",
    withdrawAmount: "จำนวนเงินที่ถอน",
    pleaseEnterWithdrawAmount: "กรุณาป้อนจำนวนเงินที่ถอน",
    remainingBalance: "ยอดเงินคงเหลือ",
    until: "จนถึง：",
    rounds: "จำนวนรอบ ",
    tradeCategory: "หมวดหมู่ธุรกรรม",
    singleRound: "ซื้อขายรอบเดียว",
    operation: "ดำเนินงาน",
    user: "ผู้ใช้",
    name: "ชื่อ",
    lastname: "นามสกุล",
    cryptoAddress: "ที่อยู่ คริบโต",
    network: "เครือข่าย",
    accountType: "ประเภทบัญชี",
    crypto: "คริบโต",
    bank: "ธนาคาร",
    logout: "ออกจากระบบ",
    settingLanguage: "ตั้งค่าภาษา",
    investAmount: "จำนวนเงินลงทุนครั้งเดียว",
    profitAmount: "จำนวนกำไร",
    transactionType: "ประเภทรายการ",
    time: "เวลา",
    investSuccess: "ความสำเร็จในการลงทุน",
    investFail: "ความล้มเหลวในการลงทุน",
    status: "สถานะ",
    history: "ประวัติ",
    eventDetail: "รายละเอียดกิจกรรม",
    personalLoan: "สินเชื่อส่วนบุคคลที่ไม่มีหลักประกัน",
    hotProduct: "สินค้ายอดนิยม",
    marketTrend: "การเปลี่ยนแปลงของตลาด",
    deposit: "ฝากเงิน",
    enterAmount: "ป้อนจำนวนเงิน",
    deleteConfirm: "คุณแน่ใจหรือว่าจะลบ?",
    depositList: "รายการฝากประจำ",
    depositDate: "วันที่ฝาก",
    profit: "รายได้",
    usernameMustBeEnglish: "ชื่อผู้ใช้ต้องเป็นภาษาอังกฤษ",
    personalData: "ข้อมูลส่วนตัว",
    general: "ทั่วไป",
    verification: "การยืนยัน",
    verifyNow: "ยืนยันตอนนี้",
    balanceHistory: "ประวัติยอดคงเหลือ",
    other: "อื่นๆ",
    email: "อีเมล",
    phoneNumber: "หมายเลขโทรศัพท์",
    emailOrPhone: "อีเมลหรือโทรศัพท์มือถือ",
    userId: "ไอดีผู้ใช้",
    emailRequired: "จำเป็นต้องใส่อีเมล",
    phoneNumberRequired: "จำเป็นต้องใส่หมายเลขโทรศัพท์",
    emailOrPhoneRequired: "กรุณาระบุอีเมลหรือหมายเลขโทรศัพท์",
    invalidEmailOrPhone: "กรุณาระบุอีเมลหรือหมายเลขโทรศัพท์ที่ถูกต้อง",
    invalidEmail: "กรุณาใส่ที่อยู่อีเมลที่ถูกต้อง",
    invalidPhone: "กรุณาใส่หมายเลขโทรศัพท์ที่ถูกต้อง",
    passwordRequired: "จำเป็นต้องใส่รหัสผ่าน",
    tradeNotice: "เปิดเทรดได้โดยไม่ต้องมีการยืนยัน (เฉพาะบัญชีจริงเท่านั้น)",
    binary: "ไบนารี",
    sellTradeConfirm: "ขายเทรดโดยไม่ต้องยืนยัน",
    notifications: "การแจ้งเตือน",
    closeTrade: "แจ้งเตือนผลลัพธ์เทรดที่ถูกปิด",
    supportTeamAlert: "แจ้งเตือนข้อความจากทีมงานช่วยเหลือ",
    welcome: "ยินดีต้อนรับสู่",
    signUpWithEmailOrPhone: "ลงทะเบียนด้วยอีเมลหรือโทรศัพท์มือถือ",
    accountVerification: "การยืนยันบัญชี",
    emailConfirmation: "การยืนยันอีเมล",
    confirmSuccessfully: "การยืนยันสำเร็จเรียบร้อย",
    continue: "ต่อไป",
    backToProfile: "กลับไปที่โปรไฟล์",
    checkInbox: "ตรวจกล่องจดหมายของคุณ",
    emailSent: "เราได้ส่งรหัสยืนยันไปยังอีเมลของคุณ",
    enterCode: "ใส่รหัสจากอีเมล",
    ifDontReceive: "หากคุณไม่ได้รับรหัส คุณสามารถ",
    requestNewCode: "ขอรหัสใหม่ได้",
    skipThisStep: "ข้ามขั้นตอนนี้ไป",
    personalDetail: "ข้อมูลส่วนตัว",
    personalDetailDes:
      "การให้ข้อมูลส่วนบุคคลที่ถูกต้องจะช่วยอำนวยความสะดวกในการตรวจสอบบัญชีและเงินทุนของคุณ รายละเอียดที่คุณให้จะถูกเก็บไว้เป็นความลับ",
    personalInfo: "ข้อมูลส่วนตัว",
    personalInfoDes1: "ระบุข้อมูลส่วนตัวของคุณ",
    personalInfoDes2: "ตามที่แสดงบนบัตรประจำตัวเพื่อ",
    personalInfoDes3: "หลีกเลี่ยงปัญหาการยืนยันตัวตนในอนาคต",
    nameInfo: "ใส่ชื่อและนามสกุลตรงตามเอกสารระบุตัวตนของคุณ",
    male: "เพศชาย",
    female: "เพศหญิง",
    dateOfBirth: "วันเกีด",
    country: "ประเทศที่คุณถือสัญชาติ",
    address: "ที่อยู่พำนัก",
    addressNote: "โปรดตรวจสอบให้แน่ใจว่าที่อยู่ถูกต้อง",
    city: "เมือง",
    residentialAddress: "ที่อยู่พำนัก",
    postalCode: "รหัสไปรษณีย์",
    submit: "Submit",
    proofOfIdentity: "หลักฐานยืนยันตัวตน",
    proofOfIdentityInfo:
      "เอกสารที่ส่งต้องมองเห็นได้อย่างชัดเจน ขั้นตอนนี้เป็นสิ่งจำเป็นเพื่อปฏิบัติตามข้อกำหนดของหน่วยงานกำกับดูแล",
    docToShow: "เอกสารควรแสดง:",
    yourPhoto: "ภาพถ่ายของคุณ",
    yourFullname: "ชื่อเต็มของคุณ",
    expiryDate: "วันหมดอายุ",
    documentnumber: "หมายเลขเอกสาร",
    yourSignature: "ลายเซ็นต์ของคุณ",
    uploadDocuments: "อัปโหลดเอกสาร",
    chooseFileFront: "เลือกไฟล์ด้านหน้า",
    chooseFileBack: "เลือกไฟล์ด้านหลัง",
    upload: "อัปโหลดไฟล์ JPG, PNG หรือ PDF ขนาดสูงสุด 15 MB",
    or: "or",
    maxSize: "max size",
    here: "here",
    manual: "คู่มือ",
    howToAttach: "วิธีแนบเอกสารอย่างถูกต้อง",
    chooseCountry: "เลือกประเทศที่ออกเอกสาร",
    selectDocumentType: "เลือกประเภทเอกสาร",
    useValid: "เลือกประเภทเอกสารที่จะใช้ยืนยัน เช่น บัตรประชาชน หรือ พาสปอร์ต",
    passport: "หนังสือเดินทาง",
    drivingLicence: "ใบขับขี่",
    idCard: "บัตรประจำตัว",
    residencePermit: "ใบอนุญาตพักอาศัย",
    uploadInfo: "อัปโหลดรูปด้านหน้าของบัตร (พร้อมภาพถ่าย)",
    uploadDescription:
      "อัปโหลดรูปบัตรหรือเอกสารของท่าน ไม่ใช้รูปจากสำเนาหรือถ่ายซ้ำจากหน้าจอ รองรับรูปในสกุลไฟล์ JPG หรือ PNG เท่านั้น",
    chooseFile: "เลือกไฟล์",
    processing: "กำลังประมวลผล",
    uploading: "Please wait while uploading",
    withdraw: "ถอนเงิน",
    invalidOtpCode: "รหัสยืนยันไม่ถูกต้อง",
    province: "จังหวัด",
    fillDataSuccessfully: "คุณกรอกข้อมูลส่วนตัวสำเร็จแล้ว!",
    verifySuccessfully: "คุณยืนยันตัวตนสำเร็จแล้ว!",
    verifyPending: "การยืนยันตัวตนกำลังถูกตรวจสอบ",

    bankAccount: "บัญชีธนาคาร",
    accountNo: "เลขบัญชีธนาคาร",
    accountName: "ชื่อธนาคาร",
    recieverName: "ชื่อผู้รับเงิน",
    rechartRecord: "บันทึกการเติมเงิน",
    withdrawRecord: "บันทึกการถอนเงิน",
    profitRecord: "บันทึกกำไร",
    memberLevel: "ระดับสมาชิก",
    totalAssets: "สินทรัพย์ทั้งหมด",
    onlineNumber: "หมายเลขออนไลน์",
    memberID: "รหัสสมาชิก",
    goldMember: "สมาชิกระดับโกลด์",
    vipMember: "สมาชิกระดับ VIP",
    receiptType: "ประเภทใบเสร็จ",
    bankName: "ธนาคารที่เปิดบัญชี",
    viewCardRecord: "ดูบันทึกการเติมเงิน",
    supportText: "ติดต่อฝ่ายบริการลูกค้าออนไลน์",
    userNotSetWithdrawPassword: "กรุณาตั้งรหัสผ่านการถอน",
    alreadyHaveAccount: "มีบัญชีแล้ว?",
    createAccount: "สร้างบัญชี",
    password: "รหัสผ่าน",
    minCharactor: "มากกว่า 6 ตัวอักษร",
    forgetPassword: "ลืมรหัสผ่าน?",
    myTrades: "เทรดของฉัน",
    active: "ดำเนินอยู่",
    closed: "ปิดแล้ว",
    startTrading: "เริ่มเทรดเพื่อดูกิจกรรมของคุณที่นี่",
    oneMinPlus: "1 นาทีขึ้นไป",
    fiveMinPlus: "5 นาทีขึ้นไป",
    asset: "สินทรัพย์",
    yourProfile: "รูปโปรไฟล์ของคุณ",
    notAllow: "ไม่อนุญาตให้เผยแพร่:",
    sexually: "ภาพลามกอนาจาร",
    incite:
      "รูปภาพที่มีจุดประสงค์เพื่อกระตุ้นความเกลียดชังทางชาติพันธุ์หรือทางเชื้อชาติหรือความเป็นศัตรู",
    underAge: "ภาพถ่ายของผู้ที่มีอายุต่ำกว่า 18 ปี",
    copyRight: "ภาพถ่ายที่มีลิขสิทธิ์ของบุคคลที่สาม",
    imageLarger:
      "รูปภาพขนาดใหญ่กว่า 5 MB และอยู่ในรูปแบบอื่นที่ไม่ใช่ JPG หรือ PNG",
    faceMustBeClearly: "ใบหน้าของคุณในภาพถ่ายต้องมองเห็นได้อย่างชัดเจน",
    allPhotos:
      "รูปภาพและวิดีโอทั้งหมดที่คุณอัปโหลดต้องเป็นไปตามข้อกำหนดเหล่านี้ มิฉะนั้นไฟล์จะถูกลบออก",
    selectAPhoto: "เลือกรูปภาพ",
    saveChange: "บันทึกการเปลี่ยนแปลง",
    changePhoto: "เปลี่ยนภาพถ่าย",
    registerDate: "วันที่ลงทะเบียน",
    idProfile: "ไอดีโปรไฟล์",
    gender: "เพศ",
    contactInformation: "ข้อมูลการติดต่อ",
    chooseAsset: "เลือกสินทรัพย์",
    timer: "ตัวจับเวลา",
    expectReturn: "รีเทิร์นที่คาด",
    up: "ขึ้น",
    down: "ลดลง",
    investment: "การลงทุน",
    statusType: "ประเภทสถานะ",
    openingTime: "เวลาเปิด",
    cloingTime: "gเวลาปิด",
    expiringTime: "เวลาหมดอายุ",
    return: "รีเทิร์น",
    positionId: "ไอดีตำแหน่ง",
    closingMethod: "วิธีปิด",
    expired: "หมดอายุแล้ว",

    bankCardNumber: "เลขบัญชีธนาคาร",
    payee: "ผู้รับเงิน",
    USDTAddress: "ที่อยู่ USDT",
    topupNotice:
      "กรุณาติดต่อฝ่ายบริการลูกค้าออนไลน์สำหรับบัญชีค่าใช้จ่ายล่าสุด！",
    topupBankNotice:
      "หมายเลขบัญชีเติมเงินด้วยบัตรธนาคาร：กรุณาติดต่อฝ่ายบริการลูกค้าออนไลน์สำหรับบัญชีค่าใช้จ่ายล่าสุด！",
    warmRemindertitle: "เตือนความจำที่อบอุ่น",
    warmRemindertext: "รับทราบการชำระเงินด้วยรหัส QR แล้วกรอกจำนวนเงินที่จะส่ง",
    remark: "หมายเหตุ",
    pleaseEnterTheRechargeAmount: "กรุณาใส่จำนวนเงินที่เติม",
    pleaseEnterTheWithdrawAmount: "กรุณากรอกจำนวนเงินที่ถอน",
    pleaseEnterANote: "กรุณาป้อนหมายเหตุ",
    rechargeAmount: "จำนวนเงินที่เติมเงิน",
    bankCardNotice:
      "ถูกผูกมัดแล้ว หากคุณต้องการแก้ไข โปรดติดต่อฝ่ายบริการลูกค้าเพื่อยกเลิกการเชื่อมโยง",
    account: "บัญชี",
    financialBill: "ใบเรียกเก็บเงินทางการเงิน",
    totalInvestment: "เงินลงทุนทั้งหมด",
    totalIncome: "รายได้รวม",
    totalProfitAndLoss: "กำไรขาดทุนรวม",
    bankCard: "บัตรธนาคาร",
    nickname: "ชื่อเล่นของผู้ใช้",
    inputRechargeAmount: "ใส่จำนวนเงินที่เติมเงิน",
    somethingWentWrong: "มีบางอย่างผิดพลาด !",
    graphType: "ประเภทกราฟ",
    closingPrice: "ราคาปิด",
    openingPrice: "ราคาเปืด",
    closingTime: "เวลาปิด",

    haveAccount: "มีบัญชีแล้ว",
    rechargeRecord: "บันทึกการเติมเงิน",
    shortTermRoom: "สมบัติระยะสั้น-ห้องจูเนียร์",
    longTermRoom: "สมบัติระยะสั้นยาว-ห้องจูเนียร์",
    lobby: "ห้องโถง",
    distance: "ระยะทาง",
    periodLottery: "กำไรงวด",
    minutes: "นาที",
    seconds: "วินาที",
    lotteryDraw: "ผลหวย",
    period: "ระยะเวลา",
    issueNumber: "หมายเลขปัญหา",
    lotteryResult: "ผลลอตเตอรี",
    topupSuccessText: "ขอบคุณที่ใช้บริการของเรา โปรดติดต่อผู้ดูแลระบบ",
    topupSuccessTitle: "เติมเงินสำเร็จ",
    withdrawSuccessTitle: "ถอนเงินสำเร็จ",
    back: "กลับ",
    pending: "รอดำเนินการ",
    success: "สำเร็จ",
    amount: "จำนวน",
    tNo: "เลขที่",
    date: "วันที่",
    customerName: "ชื่อลูกค้า",
    pleaseConnectYourAccount: "กรุณาผูกบัญชีของคุณ",
    connectAccountSuccess: "ผูกบัญชีสำเร็จ",
    buyPoints: "แต้มชื้อ",
    buy: "ชื้อ",
    insufficientBalance: "ยอดเงินคงเหลือไม่เพียงพอ",
    pleaseEnterBuyAmount: "กรุณาใส่จำนวนเงิน",
    update: "อัปเดต",
    pleaseSelectOptions: "กรุณาเลือกตัวเลือก",
    enterMessage: "ป้อนข้อความ",
    bankPayment: "การชำระเงินด้วยบัตรธนาคาร",
    usernameExist: "หมายเลขบัญชีมีแล้ว",
    unSuccess: "ไม่สำเร็จ",
    transactionTimes: "จำนวนธุรกรรม",
    people: "คน",
    minimumPurchase: "การซื้อขั้นต่ำครั้งเดียว",
    enterMinimum: "ใส่จำนวนเงินขั้นต่ำ",
    passwordIncorrect: "รหัสผ่าน ไม่ถูกต้อง",
    minimumBalance: "ยอดเงิน ขั้นต่ำ",
    pleaseEnterAccountName: "กรุณาป้อนชื่อบัญชี",
    pleaseEnterBankName: "กรุณาป้อนชื่อธนาคาร",
    tradeMinimumBalance: "ยอดเงินขั้นต่ำไม่เพียงพอ",
    phone: "โทรศัพท์มือถือ",
  },
};

export default th;
